export const codingQuizData = [
    {
        module: "Module 1 – Python Basics: Coding Challenges",
        questions: [
            {
                id: "c1-1",
                type: "coding",
                question: "Write a Python program that prints 'Hello, World!' to the console.",
                description: "This is a basic print statement exercise. Type your code in the editor below.",
                hint: "Use the print() function with a string inside parentheses.",
                starterCode: "# Write your code here\n",
                expectedOutput: "Hello, World!",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Hello, World!",
                        description: "Should print 'Hello, World!'"
                    }
                ],
                solution: 'print("Hello, World!")',
                ariaLabel: "Coding challenge: Print Hello World. Type your Python code in the text area below."
            },
            {
                id: "c1-2",
                type: "coding",
                question: "Create a variable named 'name' and assign your name to it, then print it.",
                description: "Practice variable assignment and printing.",
                hint: "Use name = 'YourName' and then print(name)",
                starterCode: "# Create a variable and print it\n",
                expectedOutput: null, // Variable output
                testCases: [
                    {
                        input: "",
                        expectedOutput: null,
                        description: "Should create a variable named 'name' and print it",
                        checkVariables: { name: "string" }
                    }
                ],
                solution: 'name = "Riya"\nprint(name)',
                ariaLabel: "Coding challenge: Create and print a variable. Type your Python code in the text area below."
            },
            {
                id: "c1-3",
                type: "coding",
                question: "Write a program that adds two numbers (5 and 3) and prints the result.",
                description: "Practice arithmetic operations and printing.",
                hint: "Create two variables, add them, and print the result.",
                starterCode: "# Add two numbers and print the result\n",
                expectedOutput: "8",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "8",
                        description: "Should print 8 as the sum of 5 and 3"
                    }
                ],
                solution: "a = 5\nb = 3\nprint(a + b)",
                ariaLabel: "Coding challenge: Add two numbers. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 2 – Variables & Data Types: Coding Challenges",
        questions: [
            {
                id: "c2-1",
                type: "coding",
                question: "Create three variables: age (integer), height (float), and name (string), then print all three.",
                description: "Practice working with different data types.",
                hint: "Assign appropriate values to each variable and print them.",
                starterCode: "# Create variables of different types\n",
                expectedOutput: null,
                testCases: [
                    {
                        input: "",
                        expectedOutput: null,
                        description: "Should create variables of correct types and print them",
                        checkVariables: {
                            age: "number",
                            height: "number",
                            name: "string"
                        }
                    }
                ],
                solution: 'age = 25\nheight = 5.8\nname = "Riya"\nprint(age)\nprint(height)\nprint(name)',
                ariaLabel: "Coding challenge: Create variables of different types. Type your Python code in the text area below."
            },
            {
                id: "c2-2",
                type: "coding",
                question: "Convert the string '42' to an integer and add 8 to it, then print the result.",
                description: "Practice type conversion and arithmetic.",
                hint: "Use int() to convert the string, then add 8.",
                starterCode: "# Convert and add\nnum_str = '42'\n",
                expectedOutput: "50",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "50",
                        description: "Should print 50"
                    }
                ],
                solution: "num_str = '42'\nresult = int(num_str) + 8\nprint(result)",
                ariaLabel: "Coding challenge: Type conversion and addition. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 3 – Operators & Expressions: Coding Challenges",
        questions: [
            {
                id: "c3-1",
                type: "coding",
                question: "Calculate the remainder when 17 is divided by 5 and print the result.",
                description: "Practice using the modulo operator.",
                hint: "Use the % operator for modulo division.",
                starterCode: "# Calculate remainder\n",
                expectedOutput: "2",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "2",
                        description: "Should print 2"
                    }
                ],
                solution: "result = 17 % 5\nprint(result)",
                ariaLabel: "Coding challenge: Calculate remainder using modulo. Type your Python code in the text area below."
            },
            {
                id: "c3-2",
                type: "coding",
                question: "Check if the number 15 is greater than 10 AND less than 20, print True or False.",
                description: "Practice using logical operators.",
                hint: "Use the 'and' operator to combine conditions.",
                starterCode: "# Check conditions\nnum = 15\n",
                expectedOutput: "True",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "True",
                        description: "Should print True"
                    }
                ],
                solution: "num = 15\nresult = num > 10 and num < 20\nprint(result)",
                ariaLabel: "Coding challenge: Use logical operators. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 4 – Input & Output: Coding Challenges",
        questions: [
            {
                id: "c4-1",
                type: "coding",
                question: "Take a user's name as input and greet them with 'Hello, [name]!'",
                description: "Practice using input() and f-strings.",
                hint: "Use input() to get the name and f-string to format the greeting.",
                starterCode: "# Get user input and greet\n",
                expectedOutput: null,
                testCases: [
                    {
                        input: "Riya",
                        expectedOutput: "Hello, Riya!",
                        description: "Should greet the user by name"
                    }
                ],
                solution: 'name = input("Enter your name: ")\nprint(f"Hello, {name}!")',
                ariaLabel: "Coding challenge: Get user input and create greeting. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 5 – Conditional Statements: Coding Challenges",
        questions: [
            {
                id: "c5-1",
                type: "coding",
                question: "Write a program that checks if a number is positive, negative, or zero.",
                description: "Practice using if-elif-else statements.",
                hint: "Use if, elif, and else to check the three conditions.",
                starterCode: "# Check if number is positive, negative, or zero\nnum = 5\n",
                expectedOutput: "Positive",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Positive",
                        description: "Should print 'Positive' for num = 5"
                    }
                ],
                solution: 'num = 5\nif num > 0:\n    print("Positive")\nelif num < 0:\n    print("Negative")\nelse:\n    print("Zero")',
                ariaLabel: "Coding challenge: Check number sign using conditionals. Type your Python code in the text area below."
            },
            {
                id: "c5-2",
                type: "coding",
                question: "Check if a number is even or odd and print the result.",
                description: "Practice using modulo operator with conditionals.",
                hint: "Use the % operator to check if divisible by 2.",
                starterCode: "# Check even or odd\nnum = 7\n",
                expectedOutput: "Odd",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Odd",
                        description: "Should print 'Odd' for num = 7"
                    }
                ],
                solution: 'num = 7\nif num % 2 == 0:\n    print("Even")\nelse:\n    print("Odd")',
                ariaLabel: "Coding challenge: Check if number is even or odd. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 6 – Loops: Coding Challenges",
        questions: [
            {
                id: "c6-1",
                type: "coding",
                question: "Print numbers from 1 to 5 using a for loop.",
                description: "Practice using for loops with range().",
                hint: "Use for i in range(1, 6):",
                starterCode: "# Print numbers 1 to 5\n",
                expectedOutput: "1\n2\n3\n4\n5",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "1\n2\n3\n4\n5",
                        description: "Should print numbers 1 through 5 on separate lines"
                    }
                ],
                solution: "for i in range(1, 6):\n    print(i)",
                ariaLabel: "Coding challenge: Print numbers using a for loop. Type your Python code in the text area below."
            },
            {
                id: "c6-2",
                type: "coding",
                question: "Calculate the sum of numbers from 1 to 10 using a loop.",
                description: "Practice using loops with accumulation.",
                hint: "Create a sum variable and add each number in the loop.",
                starterCode: "# Calculate sum of 1 to 10\n",
                expectedOutput: "55",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "55",
                        description: "Should print 55"
                    }
                ],
                solution: "total = 0\nfor i in range(1, 11):\n    total += i\nprint(total)",
                ariaLabel: "Coding challenge: Calculate sum using a loop. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 7 – Functions: Coding Challenges",
        questions: [
            {
                id: "c7-1",
                type: "coding",
                question: "Create a function called 'greet' that takes a name parameter and returns 'Hello, [name]!'",
                description: "Practice defining and using functions.",
                hint: "Use def greet(name): and return statement.",
                starterCode: "# Define a greet function\n",
                expectedOutput: null,
                testCases: [
                    {
                        input: "",
                        expectedOutput: null,
                        description: "Should define a function that returns a greeting",
                        checkFunction: {
                            name: "greet",
                            params: ["Riya"],
                            expectedReturn: "Hello, Riya!"
                        }
                    }
                ],
                solution: 'def greet(name):\n    return f"Hello, {name}!"\n\nprint(greet("Riya"))',
                ariaLabel: "Coding challenge: Create a greeting function. Type your Python code in the text area below."
            },
            {
                id: "c7-2",
                type: "coding",
                question: "Create a function that takes two numbers and returns their sum.",
                description: "Practice function parameters and return values.",
                hint: "Define a function with two parameters and return their sum.",
                starterCode: "# Define an add function\n",
                expectedOutput: null,
                testCases: [
                    {
                        input: "",
                        expectedOutput: null,
                        description: "Should define a function that adds two numbers",
                        checkFunction: {
                            name: "add",
                            params: [5, 3],
                            expectedReturn: 8
                        }
                    }
                ],
                solution: "def add(a, b):\n    return a + b\n\nprint(add(5, 3))",
                ariaLabel: "Coding challenge: Create an addition function. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 8 \u2013 Lists & Data Structures: Coding Challenges",
        questions: [
            {
                id: "c8-1",
                type: "coding",
                question: "Create a list of your three favorite fruits and print the second fruit.",
                description: "Practice creating and accessing lists.",
                hint: "Lists are created using square brackets []. Remember list indices start at 0.",
                starterCode: "# Create a list of fruits\n",
                expectedOutput: null,
                testCases: [
                    {
                        input: "",
                        expectedOutput: null,
                        description: "Should select the second fruit from a list",
                        checkVariables: { fruits: "list" }
                    }
                ],
                solution: 'fruits = ["Apple", "Banana", "Cherry"]\nprint(fruits[1])',
                ariaLabel: "Coding challenge: Create and access a list. Type your Python code in the text area below."
            },
            {
                id: "c8-2",
                type: "coding",
                question: "Append a new fruit 'Orange' to the existing list and print the updated list.",
                description: "Practice modifying lists.",
                hint: "Use the .append() method to add an item to the end of a list.",
                starterCode: "# Append to list\nfruits = ['Apple', 'Banana']\n",
                expectedOutput: "['Apple', 'Banana', 'Orange']",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "['Apple', 'Banana', 'Orange']",
                        description: "Should append Orange to the list"
                    }
                ],
                solution: "fruits = ['Apple', 'Banana']\nfruits.append('Orange')\nprint(fruits)",
                ariaLabel: "Coding challenge: Append an item to a list. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 9 \u2013 Dictionaries: Coding Challenges",
        questions: [
            {
                id: "c9-1",
                type: "coding",
                question: "Create a dictionary with student 'name' as 'Alice' and 'age' as 20, then print the student's name.",
                description: "Practice creating and accessing dictionaries.",
                hint: "Dictionaries use curly braces {} with key-value pairs separated by colons.",
                starterCode: "# Create a dictionary and print the name\n",
                expectedOutput: "Alice",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Alice",
                        description: "Should print 'Alice'"
                    }
                ],
                solution: 'student = {"name": "Alice", "age": 20}\nprint(student["name"])',
                ariaLabel: "Coding challenge: Create and access a dictionary. Type your Python code in the text area below."
            },
            {
                id: "c9-2",
                type: "coding",
                question: "Add a new key 'grade' with value 'A' to the existing student dictionary.",
                description: "Practice adding new key-value pairs to a dictionary.",
                hint: "Use dictionary[key] = value syntax.",
                starterCode: "# Add new key to dictionary\nstudent = {'name': 'Alice'}\n",
                expectedOutput: "{'name': 'Alice', 'grade': 'A'}",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "{'name': 'Alice', 'grade': 'A'}",
                        description: "Should print the updated dictionary"
                    }
                ],
                solution: "student = {'name': 'Alice'}\nstudent['grade'] = 'A'\nprint(student)",
                ariaLabel: "Coding challenge: Add key to dictionary. Type your Python code in the text area below."
            }
        ]
    },
    {
        module: "Module 10 \u2013 Error Handling: Coding Challenges",
        questions: [
            {
                id: "c10-1",
                type: "coding",
                question: "Add a try-except block to gracefully handle division by zero.",
                description: "Practice catching exceptions.",
                hint: "Wrap the division operation in a try block, and handle ZeroDivisionError in the except block.",
                starterCode: "# Add try-except block\nnumerator = 10\ndenominator = 0\n",
                expectedOutput: "Cannot divide by zero",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Cannot divide by zero",
                        description: "Should print error message instead of crashing"
                    }
                ],
                solution: 'numerator = 10\ndenominator = 0\ntry:\n    result = numerator / denominator\n    print(result)\nexcept ZeroDivisionError:\n    print("Cannot divide by zero")',
                ariaLabel: "Coding challenge: Handle division by zero. Type your Python code in the text area below."
            },
            {
                id: "c10-2",
                type: "coding",
                question: "Use try-except to catch a ValueError when trying to convert invalid string 'abc' to an integer.",
                description: "Practice handling ValueError.",
                hint: "Catch ValueError specifically.",
                starterCode: "# Handle value error\nnumber_str = 'abc'\n",
                expectedOutput: "Invalid format",
                testCases: [
                    {
                        input: "",
                        expectedOutput: "Invalid format",
                        description: "Should catch ValueError cleanly"
                    }
                ],
                solution: "number_str = 'abc'\ntry:\n    number = int(number_str)\n    print(number)\nexcept ValueError:\n    print('Invalid format')",
                ariaLabel: "Coding challenge: Handle value error. Type your Python code in the text area below."
            }
        ]
    }
];
